<template>
  <div>
    <ul class="side-filter">
      <li :class="headerClass" class="option-all">
        <a @click="$emit('optClick', null)"
           :class="checkAllClass()">
          {{allLabel}}: <span v-if="counts">{{counts['TOTAL']}}</span>
        </a>

        <div v-if="showRelevant" style="text-align:right;float:right;">
          <input type="checkbox" id="include-relevant"
                 :checked="$store.state.verticalRelevant"
                 style="vertical-align:middle;margin-right:0px;"
                 @click="$emit('relevantClick')">
          <label for="include-relevant" class="ti-p" style="font-size:12px;">
            relevant
          </label>
          <span title="Includes case studies from non-selected sectors
that are potentially relevant to selected sectors."
                style="color:rgba(0,0,0,0.6);font-size:12px;">
            🛈
          </span>
        </div>

      </li>
      <template v-if="selectedOpts">
        <button class="btn btn-neutral m1"
                style="width: 90%"
                @click="$emit('advancedModal')">
          advanced options
        </button>
        <div v-for="(vals, optId) in selectedOpts['']" :key="optId"
             class="text-tag adv-val">
          {{optString(optId, vals)}}
        </div>
      </template>
      <li v-for="code in displayItems" :key="code">
        <div v-if="refMap[code].separator" style="border: 1px solid grey; margin-bottom:3px;"></div>
        <a @click="$emit('optClick', code)"
           :class="[checkClass(code), filterEnabled(code), filterEmphasis(code)]"
           :title="definition(code)"
           >
          {{refMap[code].label}}
          <span v-if="counts">({{counts[code] || 0}})</span>
        </a>
        <!-- option details (CaseStudy Solution Characteristics) -->
        <div v-if="selectedOpts && filters[code]">
          <div v-for="(vals, optId) in selectedOpts[code]" :key="optId"
               class="text-tag adv-val">
            {{optString(optId, vals)}}
          </div>
        </div>
      </li>
    </ul>
    <div v-if="alwaysExpanded===null" class="side-filter-mode">
      <a v-if="mode=='collapsed'" @click="mode='expanded'">show all</a>
      <a v-else @click="mode='collapsed'">show less</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideFilterGroup',
  components: { },
  props: {
    headerClass: null,
    allLabel: null,
    filters: null, // currently selected {refMap key: boolean}
    counts: null,
    refMap: null, // { pos, label, def, separator:bool (before item)}
    charMap: null,
    selectedOpts: null, // show details of active
    showRelevant: null,
    alwaysExpanded: { default: null },
    // deprecated: use refMap.def
    defs: { default: null }, // show defintion on hover
    emphasis: { default: null }, // i.e. accessible to user, shows label with underline
  },

  data() {
    return {
      mode: this.alwaysExpanded ? 'expanded' : 'collapsed',
    };
  },

  created() {
  },

  computed: {
    itemsByPos() {
      const items = Object.keys(this.refMap);
      // sort items by Position
      items.sort((a, b) => (
        this.refMap[a].pos - this.refMap[b].pos
      ));
      return items;
    },

    itemsByCount() {
      if (this.counts === null) {
        return Object.keys(this.refMap);
      }
      const items = Object.keys(this.refMap);
      items.sort((b, a) => {
        if (this.emphasis !== null) {
          const access = Number(this.emphasis[a] || 0) - Number(this.emphasis[b] || 0);
          if (access) {
            return access;
          }
        }
        const aCount = this.counts[a] || 0;
        const bCount = this.counts[b] || 0;
        return aCount - bCount;
      });
      return items;
    },

    displayItems() {
      if (this.mode === 'expanded') {
        return this.itemsByPos;
      }

      // divided in two arrays, selected items always shown on top
      const sel = []; // selected items
      const byPos = this.itemsByPos;
      for (let i = 0; i < byPos.length; i++) {
        if (this.filters[byPos[i]]) {
          sel.push(byPos[i]);
        }
      }
      // show only 3 unselected items
      const un = []; // unselected
      const byCount = this.itemsByCount;
      for (let i = 0; i < byCount.length; i++) {
        if (!this.filters[byCount[i]]) {
          un.push(byCount[i]);
        }
      }
      return sel.concat(un.slice(0, 3));
    },
  },

  methods: {
    checkClass(code) {
      return this.filters[code] ? 'filter-selected' : 'filter-unselected';
    },
    checkAllClass() {
      if (Object.keys(this.filters).length === 0) {
        return 'filter-selected';
      }
      return 'filter-unselected';
    },
    filterEnabled(code) {
      if (this.counts === null) {
        return null;
      }
      if (this.counts[code]) {
        return null;
      }
      return 'filter-disabled';
    },
    filterEmphasis(code) {
      if (this.emphasis && this.emphasis[code]) {
        return 'filter-emphasis';
      }
      return null;
    },

    optString(optId, vals) {
      let text = `${this.charMap[optId].title}: `;
      vals.sort();
      text += vals.map((x) => this.charMap[optId].opts[x].label).join('; ');
      return text;
    },

    definition(code) {
      if (this.refMap[code].def) {
        return this.refMap[code].def;
      }
      if (this.defs && code in this.defs) {
        return this.defs[code];
      }
      return null;
    },
  },
};
</script>

<style>
  .side-filter {
    font-size:12px;
    line-height: 16px;
    /* border-left: 2px solid #94C232; */
  }
  .side-filter li {
    padding: 2px 8px;
    font-family: Tahoma;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.04em;
    color: #000000;
  }
  .side-filter li a{
      cursor: pointer;
  }
  .side-filter li.option-all {
    opacity: 0.8;
    padding: 14px 8px;
    border-radius: 4px;
  }

  .side-filter-mode {
    cursor: pointer;
    font-family: Tahoma;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.04em;
    color: #9B99CB; /* purple */
    padding: 0.3em 2.1em;
  }

  .filter-disabled {
    color: rgba(0, 0, 0, 0.4);
  }
  .filter-selected {
    font-weight: bold;
  }
  .filter-unselected::before {
    display: inline-block;
    content: "☐";
    font-weight: bold;
    font-size: 1.1em;
    vertical-align: bottom;
  }
  /* ☑ ☒ */
  .filter-selected::before {
    display: inline-block;
    content: "✓";
    font-weight: bold;
    font-size: 1.1em;
    vertical-align: bottom;
  }

  .filter-emphasis {
    /* text-decoration: underline; */
  }

  .adv-val {
    display: block;
    margin-left: 10px;
    margin-right: 20px;
    margin-bottom: 3px;
    font-size: 12px;
    line-height: 15px;
    text-align: left;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
